import "./Home.css";
import homeImage from "./../../assets/sainik_banner1-1.png";
import homeImage1 from "./../../assets/carousel1.png";
import dummy from "./../../assets/dummy.png";
import cm from "./../../assets/saini.jpg";
import rao from "./../../assets/minister-rao-narbir-singh.jpg";
import vij from "./../../assets/vij1.jpeg";
import jaideep from "./../../assets/jaideep.jpeg";
import neeraj from "./../../assets/neeraj.jpeg";
import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faBriefcase,
  faCamera,
  faChalkboardTeacher,
  faCheckCircle,
  faCheckDouble,
  faCircle,
  faDotCircle,
  faInfoCircle,
  faMedkit,
  faPhone,
  faShop,
  faUserShield,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import gimg from "./../../assets/gallery.png";
import img1 from "./../../assets/indiagov.jpg";
import img2 from "./../../assets/defence.jpg";
import img3 from "./../../assets/stateicon.jpg";
import img4 from "./../../assets/swachhbharat.jpg";
import img5 from "./../../assets/g20logo.png";
import NalsaScheme from "../../assets/NALSA Scheme for Defence.pdf";
import LegalAid from "../../assets/Legal Aid Clinics.docx";
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  CardImg,
  Container,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BaseUrl from "../../base-api";
import AxiosInstance from "../Utility/AxiosInstance";
import { handleAxiosError } from "../Utility/handleAxiosError";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [capfRegistrationTotal, setCapfRegistrationTotal] = useState(0);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);
  const [carouselItems, setCarouselItems] = useState([
    {
      src: homeImage,
      key: 1,
    },
    {
      src: homeImage1,
      key: 2,
    },
    {
      src: homeImage,
      key: 3,
    },
    {
      src: homeImage1,
      key: 4,
    },
  ]);
  const [notifications, setNotifications] = useState([]);
  const [links, setLinks] = useState([]);

  // CAPF district counts — separate so other API failures don't hide this item
  useEffect(() => {
    const fetchCapfCounts = async () => {
      try {
        const resCapfCounts = await AxiosInstance.get(
          `${BaseUrl}/api/public/capf/district-counts`
        );
        if (resCapfCounts.data.status === 200 && resCapfCounts.data.data) {
          setCapfRegistrationTotal(resCapfCounts.data.data.total ?? 0);
        } else {
          setCapfRegistrationTotal(0);
        }
      } catch (capfError) {
        console.log("Failed to fetch CAPF district counts.", capfError);
        setCapfRegistrationTotal(0);
      }
    };
    fetchCapfCounts();
  }, []);
 
  useEffect(() => {
    const fetchData = async () => {
      dispatch(isloading());
      try {
        const res = await AxiosInstance.post(
          `${BaseUrl}/api/v1/files/getImages`,
          { location: "Gallery" },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (res.data.status === 200) {
          const processedImages = res.data.data.content.map((img, index) => ({
            src: img.file ? `data:image/png;base64,${img.file}` : "",
            key: index + 1,
          }));
          setItems(processedImages);
        } else {
          console.log(res.data.message || "Failed to load images.");
        }
        const resNote = await AxiosInstance.post(
          `${BaseUrl}/api/notifications/getNotification`,
          { location: "All" },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        if (resNote.data.status === 200) {
          setNotifications(
            resNote.data.data.content.map((img) => ({
              id: img.key,
              title: img.title,
              file: `data:application/pdf;base64,${img.file}` || "",
              location: img.location,
            }))
          );
        } else {
          console.log("Failed to fetch Notifications.");
        }

        const resLink = await AxiosInstance.post(
          `${BaseUrl}/api/links/getAll`,
          { location: "All" },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (resLink.data.status === 200) {
          setLinks(
            resLink.data.data.content.map((img) => ({
              id: img.key,
              title: img.title,
              link: img.link || "",
              location: img.location,
            }))
          );
        } else {
          console.log("Failed to fetch links.");
        }
      } catch (error) {
        handleAxiosError(error);
      } finally {
        dispatch(isloading());
      }
    };

    if (location.pathname) fetchData();
  }, [location.pathname]);

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [activeIndex1, setActiveIndex1] = useState(0);
  const [animating1, setAnimating1] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  const next1 = () => {
    if (animating1) return;
    const nextIndex =
      activeIndex1 === carouselItems.length - 1 ? 0 : activeIndex1 + 1;
    setActiveIndex1(nextIndex);
  };

  const previous1 = () => {
    if (animating1) return;
    const nextIndex =
      activeIndex1 === 0 ? carouselItems.length - 1 : activeIndex1 - 1;
    setActiveIndex1(nextIndex);
  };

  const goToIndex1 = (newIndex) => {
    if (animating1) return;
    setActiveIndex1(newIndex);
  };

  const slides = items?.map((item, index) => {
    let slideClass = "";
    if (index === activeIndex) {
      slideClass = "active";
    } else if (
      index === (activeIndex === 0 ? items.length - 1 : activeIndex - 1)
    ) {
      slideClass = "carousel-item-prev";
    } else if (
      index === (activeIndex === items.length - 1 ? 0 : activeIndex + 1)
    ) {
      slideClass = "carousel-item-next";
    }
    return (
      <CarouselItem
        className={slideClass}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img
          src={item.src}
          alt={item.altText}
          width="100%"
          height={"350px"}
          className="gallerymob"
        />
        <CarouselCaption
          captionText={item.caption}
          captionHeader={item.caption}
        />
      </CarouselItem>
    );
  });
  const carouselslides = carouselItems?.map((item, index) => {
    let slideClass = "";
    if (index === activeIndex1) {
      slideClass = "active";
    } else if (
      index ===
      (activeIndex1 === 0 ? carouselItems.length - 1 : activeIndex1 - 1)
    ) {
      slideClass = "carousel-item-prev";
    } else if (
      index ===
      (activeIndex1 === carouselItems.length - 1 ? 0 : activeIndex1 + 1)
    ) {
      slideClass = "carousel-item-next";
    }
    return (
      <CarouselItem
        className={slideClass}
        onExiting={() => setAnimating1(true)}
        onExited={() => setAnimating1(false)}
        key={item.src}
      >
        <img src={item.src} alt={item.altText} width="100%" />
        <CarouselCaption
          captionText={item.caption}
          captionHeader={item.caption}
        />
      </CarouselItem>
    );
  });
  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, 3000);
    return () => clearInterval(interval);
  }, [activeIndex, animating]);

  useEffect(() => {
    const interval = setInterval(() => {
      next1();
    }, 3000);
    return () => clearInterval(interval);
  }, [activeIndex1, animating1]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (items.length > 0) {
        setActiveIndex(0);
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [items]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (carouselItems.length > 0) {
        setActiveIndex1(0);
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [carouselItems]);

  const [combinedItems, setCombinedItems] = useState([]);
  const capfStatsItem = {
    id: "capf-district-stats",
    title: `Total CAPF Registrations (District-wise): ${capfRegistrationTotal}`,
    url: "/capf-registration-district-counts",
    type: "capf-district-stats",
  };

  useEffect(() => {
    // Only admin notifications + important links scroll; CAPF stays fixed above
    setCombinedItems([
      ...notifications.map((notification) => ({
        id: notification.id,
        title: notification.title,
        url: notification.file || "",
        type: "notification",
      })),
      ...links
        .filter((link) => link.location === "Important Link")
        .map((link) => ({
          title: link.title,
          url: link.link || "",
          type: "link",
        })),
    ]);
  }, [links, notifications]);

  const renderNotificationItem = (item, key) => (
    <li
      key={key}
      className="d-flex align-items-center py-3 px-3 mb-2"
      style={{
        background: "rgba(255, 255, 255, 0.8)",
        borderRadius: "10px",
        border: "1px solid rgba(202, 101, 18, 0.1)",
        transition: "all 0.3s ease",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
        e.currentTarget.style.transform = "translateX(5px)";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(202, 101, 18, 0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(255, 255, 255, 0.8)";
        e.currentTarget.style.transform = "translateX(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <span className="icon">
        <FontAwesomeIcon
          icon={faCheckCircle}
          className="me-3"
          style={{
            color: "#ca6512",
            fontSize: "1.2rem",
            animation: "pulse 2s infinite",
          }}
        />
      </span>
      <span className="content flex-grow-1">
        <span
          className="text-dark fw-semibold"
          onClick={() => handleItemClick(item)}
          style={{
            textDecoration: "none",
            cursor: "pointer",
            fontSize: "1rem",
            lineHeight: "1.4",
          }}
        >
          {item.title}
        </span>
      </span>
      <span className="arrow">
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{
            color: "#ca6512",
            fontSize: "0.9rem",
            opacity: "0.7",
          }}
        />
      </span>
    </li>
  );


 const handleItemClick = async (item) => {
  try {
    if (item.type === "capf-district-stats") {
      navigate("/capf-registration-district-counts");
      return;
    }

    if (item.type === "notification") {
      const resNote = await fetch(`${BaseUrl}/api/notifications/document/${item.id}`, {
        method: "GET",
      });

      if (resNote.ok) {
        const blob = await resNote.blob(); 
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      } else {
        console.log("Failed to download notification.");
      }
    }

    if (item.type === "link" && item.url) {
      window.open(item.url, "_blank", "noopener,noreferrer");
    }
  } catch (error) {
    console.error("Error fetching item data:", error);
  }
};

  return (
    <div>
      <div>
        {/* <img width={"100%"} src={homeImage} alt="img" />  */}
        <Carousel
          key={carouselItems.length}
          style={{
            width: "100%",
          }}
          activeIndex={activeIndex1}
          next={next1}
          slide={false}
          previous={previous1}
          interval={2000}
          // ride="carousel"
        >
          <CarouselIndicators
            items={carouselItems}
            activeIndex={activeIndex1}
            onClickHandler={goToIndex1}
          />
          {carouselslides}
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={previous1}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={next1}
          />
        </Carousel>
      </div>
      <div
        className="container-fluid"
        id="important-updates"
        style={{
          background: "linear-gradient(150deg, #f3c55d 0%, #f5d371 100%)",
        }}
      >
        <Row>
          <Col md={2} xs={3} style={{ background: "#ad2c2ce0",borderEndEndRadius:"5px", borderStartEndRadius:"5px" }}>
            <h5 className="text-center mt-2 updates-heading" style={{ color: "white" }}>
              Important Updates
            </h5>
          </Col>
          <Col md={10} xs={9} className="marquee-container" style={{ background: "#f5f5f5" }}>
            <div className="marquee-content">
              {links
                .filter((link) => link.location === "Important Updates")
                .map((link, index) => (
                  <div
                    key={index}
                    className="carousel-item-content"
                    style={{ paddingRight: "40px" }}
                  >
                    <h5 className="mt-2 fw-semibold">
                      <a
                        href={link.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.title}
                      </a>
                    </h5>
                  </div>
                ))}
            </div>
          </Col>
        </Row>
      </div>
      <div className="container-fluid">
        <div className=" row justify-content-center">
          <div className="col-md-12 col-xs-12" style={{background:'#c1d3863d'}}>
            <div className="mt-4 p-4 animate-on-scroll animate-fade-up" id="main-cards">
              
              
              {/* First Row - 3 Cards */}
              <div className="row justify-content-center mb-4">
                <div className="col-md-4 col-sm-6 col-12 mb-4">
                  <div className="card-container-wrapper animate-on-scroll animate-scale-up" id="card-1">
                    <Card className="d-flex flex-column justify-content-around align-items-center border-0 cardimg shadow-lg hover-lift" style={{ maxWidth: "350px", background: "#eeeeee" }}>
                      <CardImg
                        className="mt-3"
                        src={cm}
                        alt="Chief Minister"
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          border: "6px solid rgb(240, 242, 243)",
                        }}
                      />
                      <CardBody className="text-center">
                        <p className="card-text fw-bold text-center w-100">Shri Nayab Singh Saini</p>
                        <CardTitle tag="h5">Hon'ble Chief Minister of Haryana</CardTitle>
                      </CardBody>
                    </Card>
                  </div>
                </div>
                
                <div className="col-md-4 col-sm-6 col-12 mb-4">
                  <div className="card-container-wrapper animate-on-scroll animate-scale-up" id="card-2">
                    <Card className=" d-flex flex-column justify-content-center align-items-center border-0 cardimg shadow-lg hover-lift" style={{ maxWidth: "350px", background: "#eeeeee" }}>
                      <CardImg
                        className="mt-3"
                        src={rao}
                        alt="Minister of State"
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          border: "6px solid rgb(240, 242, 243)",
                        }}
                      />
                      <CardBody className="text-center">
                        <p className="card-text fw-bold">Shri Rao Narbir Singh</p>
                        <CardTitle tag="h5">Hon'ble Minister</CardTitle>
                      </CardBody>
                    </Card>
                  </div>
                </div>
                
                <div className="col-md-4 col-sm-6 col-12 mb-4">
                  <div className="card-container-wrapper animate-on-scroll animate-scale-up" id="card-3">
                    <Card className=" d-flex flex-column justify-content-center align-items-center border-0 cardimg shadow-lg hover-lift" style={{ maxWidth: "350px", background: "#eeeeee" }}>
                      <CardImg
                        className="mt-3"
                        src={vij}
                        alt="Administrative Secretary"
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          border: "6px solid rgb(240, 242, 243)",
                        }}
                      />
                      <CardBody className="text-center">
                        <p className="card-text fw-bold">
                         Shri Vijayendra Kumar (IAS)
                        </p>
                        <CardTitle tag="h5">Additional Chief Secretary</CardTitle>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </div>
              
              <div className="row justify-content-center">
                <div className="col-md-4 col-sm-6 col-12 mb-4 d-flex justify-content-center">
                  <div className="card-container-wrapper animate-on-scroll animate-scale-up" id="card-4">
                    <Card className=" d-flex flex-column justify-content-center align-items-center border-0 cardimg shadow-lg hover-lift" style={{ maxWidth: "350px", background: "#eeeeee" }}>
                      <CardImg
                        className="mt-3"
                        src={jaideep}
                        alt="Director"
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          border: "6px solid rgb(240, 242, 243)",
                        }}
                      />
                      <CardBody className="text-center">
                        <p className="card-text fw-bold text-center w-100">Shri Jaideep Kumar (IAS)</p>
                        <CardTitle tag="h5">Director cum Additional Secretary</CardTitle>
                      </CardBody>
                    </Card>
                  </div>
                </div>
                
                <div className="col-md-4 col-sm-6 col-12 mb-4 d-flex justify-content-center">
                  <div className="card-container-wrapper animate-on-scroll animate-scale-up" id="card-5">
                    <Card className=" d-flex flex-column justify-content-center align-items-center border-0 cardimg shadow-lg hover-lift" style={{ maxWidth: "350px", background: "#eeeeee" }}>
                      <CardImg
                        className="mt-3"
                        src={neeraj}
                        alt="Deputy Director"
                        style={{
                          width: "150px",
                          height: "150px",
                          borderRadius: "50%",
                          border: "6px solid rgb(240, 242, 243)",
                        }}
                      />
                      <CardBody className="text-center">
                        <p className="card-text fw-bold">Major Neeraj Sharma</p>
                        <CardTitle tag="h5">Deputy Director</CardTitle>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xs-12">
            <div className="mt-4 py-4 animate-on-scroll animate-fade-up" id="notifications-section" style={{ background: "linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%)", borderRadius: "20px", boxShadow: "0 8px 25px rgba(202, 101, 18, 0.15)", border: "2px solid rgba(202, 101, 18, 0.1)" }}>
              <div className="text-center mb-4">
                <h1 className="fw-bold" style={{ color: "#ca6512", fontSize: "2rem", letterSpacing: "1px", marginBottom: "10px" }}>
                  Notifications
                </h1>
                <div className="mx-auto" style={{ width: "100px", height: "3px", background: "linear-gradient(90deg, #ca6512, #ff9800)", borderRadius: "2px" }}></div>
              </div>
              <div className="px-4 mb-2">
                <ul style={{ listStyle: "none", padding: "0", margin: "0" }}>
                  {renderNotificationItem(capfStatsItem, "capf-district-stats")}
                </ul>
              </div>
              <div className="marquee-container1" style={{ padding: "5px", height: "300px", overflow: "hidden" }}>
                <div
                  className="marquee-content1"
                  style={
                    combinedItems.length <= 4
                      ? { animation: "none", transform: "none" }
                      : undefined
                  }
                >
                  <ul className="px-4" style={{ listStyle: "none", padding: "0", margin: "0" }}>
                    {combinedItems.length > 0 ? (
                      <>
                        {combinedItems.map((item, index) =>
                          renderNotificationItem(
                            item,
                            `notify-${item.id || item.type}-${index}`
                          )
                        )}
                        {combinedItems.length > 4 &&
                          combinedItems.map((item, index) =>
                            renderNotificationItem(
                              item,
                              `duplicate-${item.id || item.type}-${index}`
                            )
                          )}
                      </>
                    ) : (
                      <li className="text-center py-4" style={{ color: "#ca6512", fontStyle: "italic" }}>
                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                        To be Updated...
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
            <div className="col-md-6 col-xs-12 text-center">
            <div className="mt-4 py-4 animate-on-scroll animate-fade-up" id="gallery-section" style={{ background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)", borderRadius: "20px", boxShadow: "0 8px 25px rgba(33, 150, 243, 0.15)", border: "2px solid rgba(33, 150, 243, 0.1)" }}>
              <div className="text-center mb-4">
                <h1 className="fw-bold" style={{ color: "#1976d2", fontSize: "2rem", letterSpacing: "1px", marginBottom: "10px" }}>
                  Photo Gallery
                </h1>
                <div className="mx-auto" style={{ width: "100px", height: "3px", background: "linear-gradient(90deg, #1976d2, #42a5f5)", borderRadius: "2px" }}></div>
              </div>
              <div style={{ padding: "5px 20px" }}>
                {items.length > 0 && (
                  <>
                    <Carousel
                      key={items.length}
                      style={{
                        width: "100%",
                        height: "",
                        margin: "0 auto",
                        boxShadow: "rgba(33, 150, 243, 0.2) 0px 4px 12px 0px",
                        borderRadius: "15px",
                        overflow: "hidden"
                      }}
                      activeIndex={activeIndex}
                      next={next}
                      slide={false}
                      previous={previous}
                      interval={2000}
                    >
                      <CarouselIndicators
                        items={items}
                        activeIndex={activeIndex}
                        onClickHandler={goToIndex}
                      />
                      {slides}
                      <CarouselControl
                        direction="prev"
                        directionText="Previous"
                        onClickHandler={previous}
                      />
                      <CarouselControl
                        direction="next"
                        directionText="Next"
                        onClickHandler={next}
                      />
                    </Carousel>
                  </>
                )}
              </div>
            </div>
          </div>



          <div className="mt-3 container-fluid " id="logo-section" style={{ background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)", borderRadius: "10px", padding: "" }}>
            <div className="mb-3 pb-3">
              <div className="my-4">
                
                <div className="row justify-content-center align-items-center g-4">
                  <div className="col-md-2 col-sm-4 col-6 text-center">
                    <div className="logo-card p-3 rounded-3 shadow-sm hover-shadow transition-all animate-on-scroll animate-scale-up" id="logo-1" style={{ background: "white", minHeight: "120px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <a
                        href={"https://www.india.gov.in/"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <img
                          src={img1}
                          alt="India Gov"
                          className="img-fluid"
                          style={{ maxHeight: "80px", transition: "transform 0.3s" }}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-4 col-6 text-center">
                    <div className="logo-card p-3 rounded-3 shadow-sm hover-shadow transition-all animate-on-scroll animate-scale-up" id="logo-2" style={{ background: "white", minHeight: "120px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <a
                        href={"https://mod.gov.in/"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <img
                          src={img2}
                          alt="Defence"
                          className="img-fluid"
                          style={{ maxHeight: "80px", transition: "transform 0.3s" }}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-4 col-6 text-center">
                    <div className="logo-card p-3 rounded-3 shadow-sm hover-shadow transition-all animate-on-scroll animate-scale-up" id="logo-3" style={{ background: "white", minHeight: "120px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <a
                        href={"https://haryana.gov.in/"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <img
                          src={img3}
                          alt="Haryana Gov"
                          className="img-fluid "
                          style={{ maxHeight: "80px", transition: "transform 0.3s" }}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-4 col-6 text-center">
                    <div className="logo-card p-3 rounded-3 shadow-sm hover-shadow transition-all animate-on-scroll animate-scale-up" id="logo-4" style={{ background: "white", minHeight: "120px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <a
                        href={"https://swachhbharatmission.ddws.gov.in/"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <img
                          src={img4}
                          alt="Swachh Bharat"
                          className="img-fluid"
                          style={{ maxHeight: "80px", transition: "transform 0.3s" }}
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-4 col-6 text-center">
                    <div className="logo-card p-3 rounded-3 shadow-sm hover-shadow transition-all animate-on-scroll animate-scale-up" id="logo-5" style={{ background: "white", minHeight: "120px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <a
                        href={"https://g20.org/engagement-groups-2/"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <img
                          src={img5}
                          alt="G20"
                          className="img-fluid"
                          style={{ maxHeight: "80px", transition: "transform 0.3s" }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Home.propTypes = {};

Home.defaultProps = {};

export default Home;
